<template>
    <div class="content mt-4">
        <div class="container">
            <nav class="level is-mobile">
                <div class="level-item has-text-centered">
                    <div>
                        <p class="heading">
                            {{ timeTitle }}
                        </p>
                        <p class="title" v-if="end && start">
                            {{ (end - start) / 1e3 }}s
                        </p>
                        <p class="title" v-else-if="loading || progress">
                            <progress
                              :class="progressClass"
                              class="progress" max="100"
                              :value="progress"
                            />
                        </p>
                        <p class="title" v-else>
                            -
                        </p>
                    </div>
                </div>
                <div class="level-item has-text-centered">
                    <div>
                        <p class="heading"> Aggregated Number</p>
                        <p class="title">{{ formattedNumber }}</p>
                    </div>
                </div>
            </nav>
            <div class="has-text-centered">
                <button class="button is-link is-rounded is-outlined is-large"
                        :disabled="progress || loading"
                        @click="fetchNumbers">
                    Fetch Numbers
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import jsonpipe from 'jsonpipe'

const numberFormat =  new Intl.NumberFormat({ maximumSignificantDigits: 2 })

export default {
  name: 'XJSONStream',
  data() {
    return {
      aggregated: 0,
      loading: false,
      count: 0,
      progress: 0,
      start: null,
      end: null,
      size: 0,
      total: 0,
    }
  },

  computed: {
    timeTitle() {
      return this.loading ?
          'Connecting' : this.progress ?
              `Fetching, so far ${numberFormat.format(this.count)}/${numberFormat.format(this.total)} items...` :
              this.count === this.total ?
                  `Fetched ${numberFormat.format(this.total)} items in` : 'Nothing happening'
    },

    progressClass() {
        if (this.progress >= 10 && this.progress < 25) {
            return 'is-warning'
        } else if (this.progress >= 25 && this.progress < 40) {
            return 'is-info'
        } else if (this.progress >= 40 && this.progress < 65) {
            return 'is-link'
        } else if (this.progress >= 65 && this.progress < 80) {
            return 'is-primary'
        } else if (this.progress >= 80) {
            return 'is-success'
        }
        return 'is-danger'
    },
    formattedNumber() {
        return numberFormat.format(this.aggregated)
    },
  },

  methods: {
    reset() {
        this.start = null
        this.end = null
        this.count = 0
        this.aggregated = 0
        this.total = 0
        this.size = 0
        this.progress = 0
        this.loading = false
    },
    fetchNumbers() {
        this.reset()
        this.loading = true
        jsonpipe.flow('https://serene-spire-16243.herokuapp.com/', {
            onHeaders: () => {
                this.start = new Date()
            },
            success: data => {
                if (this.loading) this.loading = false
                if (Array.isArray(data)) {
                    this.aggregated += data.reduce((agg, x) => agg + x.number, 0)
                    this.count += this.size
                    this.progress = this.count / this.total * 100
                } else {
                    this.total = data.total
                    this.size = data.chunkSize
                }
            },
            error: () => {
                this.reset()
            },
            complete: () => {
                this.count += this.size
                this.end = new Date()
                this.progress = this.count / this.total * 100
                setTimeout(() => { this.progress = 0 }, 100)
            },
            withCredentials: false,
            delimiter: '\n',
        })
    },
  }
}
</script>

<style scoped>
.title {
    height: 36px;
}
.progress {
    top: 50%;
    transform: translateY(-50%);
    position: relative;
}
</style>
